// Hôtes UI partagés de la Console (§24.1quater) — monte UNE fois les toasts + dialogues de
// `@orgazone/ui-web` avec la charte Console : icônes locales injectées (le paquet impose le NOM,
// pas le dessin) et couleurs résolues par les variables CSS du thème (clair/sombre suivent seuls).
import { DialogHost, Icon, ToastHost, type IconName } from '@orgazone/ui-web';

// Icônes de ton : REGISTRE PARTAGÉ (`ui-tokens/icons`) — un nom = un dessin, plus de registre local.
function icon(name: IconName, size: number, color: string) {
  return <Icon name={name} size={size} color={color} stroke={2} />;
}

/** À monter une seule fois près de la racine (App). */
export function ConsoleUiHost() {
  return (
    <>
      {/* Défauts CANONIQUES du ToastHost (teintes de base indépendantes du thème — l'ancien mapping
          sur les tons -fg suivait le thème de PAGE, à contre-pied de la pilule inversée : délavé). */}
      <ToastHost />
      <DialogHost
        renderIcon={icon}
        palette={{
          overlay: 'color-mix(in srgb, #000 55%, transparent)',
          card: 'var(--panel)',
          title: 'var(--ink)',
          message: 'var(--mut)',
          tile: {
            danger: { bg: 'var(--da-bg)', fg: 'var(--da-fg)' },
            err: { bg: 'var(--da-bg)', fg: 'var(--da-fg)' },
            warn: { bg: 'var(--wa-bg)', fg: 'var(--wa-fg)' },
            info: { bg: 'var(--in-bg)', fg: 'var(--in-fg)' },
          },
          cancel: { bg: 'transparent', fg: 'var(--mut)', border: 'var(--line)' },
          action: {
            danger: { bg: 'var(--da-fg)', fg: '#fff' },
            primary: { bg: 'var(--cta)', fg: 'var(--cta-ink)' },
          },
        }}
      />
    </>
  );
}
